import Header from "../../Home/Header";
import Footer from "../../Home/Footer";

function Fouettard () {
  return (
    <div className="core">
      <Header />
      <h2 className="bloc titre">Le Père Fouettard</h2>
      <div className="bloc">
        <p>Le Père Fouettard est un personnage sinistre, tout vêtu de noir, qui accompagne Saint Nicolas dans ses tournées. Alors que Grand Saint distribue des cadeaux aux enfants qui ont été sages, le Père Fouettard distribue des coups de fouet aux petits garnements.</p>
        <p>Mais qui est-il réellement ? Une légende (une de plus ...) raconte que le Père Fouettard serait apparu au XVIème siècle. Il serait né à Metz en 1552 pendant le siège de la ville par l'armée de Charles Quint.</p>
        <p>Pour donner du courage aux habitants assiégés, la corporation des tanneurs confectionna un épouvantail grotesque, muni d'un fouet, à l'effigie de Charles-Quint. Les habitants de Metz firent une procession avec ce mannequin à travers les rues, et pour démoraliser les assaillants, l'installèrent au sommet des remparts pour y bouter le feu. Le mannequin, noircit et rendu méconnaissable par sa combustion, impressionna sûrement les petits enfants. Sans doute les parents s'en sont-ils servi pour motiver leurs enfants à rester sages ...</p>
        <p>L'année suivante, Metz fut libérée. Le personnage au fouet, qui poursuit jouvencelles et damoiseaux, sera ressuscité. Son passage coïncide avec celui de Saint Nicolas. Sa caricature restera dans les esprits sous l'appellation de Père Fouettard, un tanneur de fesses, accompagnateur de saint Nicolas, un distributeur de cadeaux.</p>
        <p>C'est sûrement à cause de cette légende que Père Fouettard est souvent représenté par un personnage à la peau noire (mannequin brûlé) habillé à la mode Renaissance (époque de Charles-Quint).</p>


      </div>
      <Footer />
    </div>

  
  )
}
export default Fouettard